import { Badge, Flex, Link, Text } from '@radix-ui/themes'
import { ExternalLinkIcon } from '@radix-ui/react-icons'
import type { ReactNode } from 'react'
import type { Ops } from '@willie/schemas'
import { integerDaysSince } from '~/features/installations/overview'

export const daysAgoLabel = (iso: string): string => {
  const days = integerDaysSince(iso)
  if (days === 0) return 'today'
  if (days === 1) return '1 day ago'
  return `${days} days ago`
}

interface TicketRowProps {
  ticket: Ops.Freshdesk.TicketLink
  // Rendered under the subject line; each surface says something different about the ticket.
  footer: ReactNode
}

export const TicketRow = ({ ticket, footer }: TicketRowProps) => (
  <Flex direction="column" gap="1">
    <Flex align="center" justify="between" gap="3">
      <Flex align="center" gap="2" minWidth="0">
        <Badge color="gray" variant="outline" size="1" className="shrink-0">
          {ticket.sourceLabel}
        </Badge>
        <Badge color={ticket.isOpen ? 'orange' : 'gray'} variant="soft" size="1" className="shrink-0">
          {ticket.statusLabel}
        </Badge>
        {/* Outside the link, which truncates: the number is the part an operator
            quotes, so it must not be the part that gets clipped. */}
        <Text size="2" color="gray" className="shrink-0 font-mono">
          #{ticket.id}
        </Text>
        <Link
          href={ticket.url}
          target="_blank"
          rel="noopener noreferrer"
          className="truncate text-[var(--accent-11)] hover:underline"
        >
          <Text size="2">{ticket.subject}</Text>
        </Link>
      </Flex>
      <Link href={ticket.url} target="_blank" rel="noopener noreferrer" className="shrink-0">
        <ExternalLinkIcon />
      </Link>
    </Flex>
    {footer}
  </Flex>
)
